var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuLinks = function SvgMenuLinks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#828D99",
    strokeLinecap: "round",
    strokeWidth: 0.4,
    d: "M9.308 7.8C6.278 7.8 3.8 10.117 3.8 13s2.477 5.2 5.508 5.2c.481 0 .892-.37.892-.852s-.41-.852-.892-.852c-2.068 0-3.723-1.576-3.723-3.496S7.24 9.504 9.308 9.504c.481 0 .892-.37.892-.852S9.79 7.8 9.308 7.8Zm7.384 0c-.481 0-.892.37-.892.852s.41.852.892.852c2.068 0 3.723 1.577 3.723 3.496s-1.655 3.496-3.723 3.496c-.481 0-.892.37-.892.852s.41.852.892.852c3.03 0 5.508-2.317 5.508-5.2s-2.477-5.2-5.508-5.2Zm-7.384 4.348c-.482 0-.893.37-.893.852s.411.852.893.852h7.384c.482 0 .893-.37.893-.852s-.411-.852-.893-.852z"
  })));
};
export { SvgMenuLinks as ReactComponent };